// hooks/useAuthForm.ts
import { useState, useCallback } from 'react'

export const useAuthForm = () => {
    // Minimal form state
    const [title, setTitle] = useState('Mr')
    const [email, setEmail] = useState('')
    const [isEmailValid, setEmailValid] = useState(true)
    const [password, setPassword] = useState('')
    const [isPasswordValid, setPasswordValid] = useState(true)
    const [firstName, setFirstName] = useState('')
    const [isValidFirstName, setFirstNameValid] = useState(true)
    const [lastName, setLastName] = useState('')
    const [isValidLastName, setLastNameValid] = useState(true)
    const [passwordType, setPasswordType] = useState(true)
    const [rememberCheckedStatus, setRememberCheckedStatus] = useState(false)
    const [travelCheckedStatus, setTravelCheckedStatus] = useState(false)

    // Form state object
    const formState = {
        title,
        email,
        isEmailValid,
        password,
        isPasswordValid,
        firstName,
        isValidFirstName,
        lastName,
        isValidLastName,
        passwordType,
        rememberCheckedStatus,
        travelCheckedStatus
    }

    // Change handlers
    const changeEmailHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setEmailValid(true)
        setEmail(e.target.value)
    }, [])

    const changePasswordHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordValid(true)
        setPassword(e.target.value)
    }, [])

    const changeFirstNameHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstNameValid(true)
        setFirstName(e.target.value)
    }, [])

    const changeLastNameHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setLastNameValid(true)
        setLastName(e.target.value)
    }, [])

    const changeTitleHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value)
    }, [])

    // Validators (very basic)
    const validateEmail = useCallback(() => {
        const valid = /.+@.+\..+/.test(email)
        setEmailValid(valid)
        return valid
    }, [email])

    const validatePassword = useCallback(() => {
        const valid = password.length > 0
        setPasswordValid(valid)
        return valid
    }, [password])

    const validateFirstName = useCallback(() => {
        const valid = firstName.length > 0
        setFirstNameValid(valid)
        return valid
    }, [firstName])

    const validateLastName = useCallback(() => {
        const valid = lastName.length > 0
        setLastNameValid(valid)
        return valid
    }, [lastName])

    const handlers = {
        changeEmailHandler,
        changePasswordHandler,
        changeFirstNameHandler,
        changeLastNameHandler,
        changeTitleHandler,
        setTitle,
        setPassword,
        setPasswordType,
        setRememberCheckedStatus,
        setTravelCheckedStatus
    }

    const validators = {
        validateEmail,
        validatePassword,
        validateFirstName,
        validateLastName
    }

    return {
        formState,
        handlers,
        validators
    }
}
